var React = require("react");

var Tab = React.createClass({
  PropTypes: {
    value: React.PropTypes.string.isRequired,
    isSelected: React.PropTypes.bool,
    isDisabled: React.PropTypes.bool,
    onTabSelect: React.PropTypes.func,
    id: React.PropTypes.string
  },

  getDefaultProps: function() {
    return {
      onTabSelect: function() {},
      isSelected: false,
      isDisabled: false,
      id: ''
    };
  },

  onTabClick: function(e) {
    e.preventDefault();
    this.props.onTabSelect(this.props.value);
  },

  render: function() {
    return (
      <button className={this._getClasses()}
        onClick={this.onTabClick}
        data-qa={this.props.id}
        tabIndex={this.props.isSelected ? -1 : 0}>
        {this.props.children}
      </button>
    );
  },

  _getClasses: function() {
    let tabClasses = 'tablist__tab';
    tabClasses += this.props.isSelected ? ' tablist__tab--selected' : '';
    tabClasses += this.props.isDisabled ? ' tablist__tab--disabled' : '';

    return tabClasses;
  }
});
module.exports = Tab;



// WEBPACK FOOTER //
// ./src/advocate/components/tabs/tab.jsx